module.exports = "/_next/static/images/num-6-82d79be7.png";